<template>
  <div class="toast-container">
    <transition-group name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast"
        :class="[toast.type, toast.show ? 'show' : '']"
      >
        <i class="fas" :class="iconClass(toast.type)"></i>
        {{ toast.message }}
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts } = useToast()

const iconClass = (type: string) => {
  switch (type) {
    case 'success': return 'fa-check-circle'
    case 'error': return 'fa-exclamation-circle'
    default: return 'fa-info-circle'
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  pointer-events: none;
}
.toast {
  background: var(--vh-azul-profundo);
  color: white;
  padding: 1.2rem 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  pointer-events: all;
  transform: translateX(120%);
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.toast.show {
  transform: translateX(0);
  opacity: 1;
}
.toast.success { background: var(--vh-verde); }
.toast.error { background: var(--vh-rojo); }
.toast.info { background: var(--vh-azul-cielo); }
</style>
